import { render, staticRenderFns } from "./CreateEditCompany.vue?vue&type=template&id=167d5b55&scoped=true&"
import script from "./CreateEditCompany.vue?vue&type=script&lang=js&"
export * from "./CreateEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d5b55",
  null
  
)

export default component.exports